import Card from "react-bootstrap/Card";

function MyGradesList(props) {
  const { exam } = props;

  const displayFormat = "DD/MM/YYYY";
  var moment = require("moment");

  //const color = "belt-"+exam.grade.color+".png";
  return (
    <Card
      id={exam.id}
      className="text-center"
      border="dark"
      style={{
        maxWidth: "600px",
        margin: "0 auto 10px auto",
      }}
    >
      <Card.Header
        style={{ fontSize: "2rem", backgroundColor: "#2323ab", color: "white" }}
      >
        {exam.grade.name}
      </Card.Header>
      <Card.Body>
        <Card.Title>{moment(exam.date).format(displayFormat)}</Card.Title>
        <Card.Text>
          Nº {exam.id}
          <br />
          {exam.dojo.name}
        </Card.Text>
        <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
      </Card.Body>
    </Card>
  );

  // <Image src={color} style={{ width: '40px', float: 'left', backgroundColor: 'white', borderRadius: '20%', padding: '5px', marginTop: '5px' }}/>
}
export default MyGradesList;
